// src/context/PermissionContext.tsx
import React, { createContext, useContext } from 'react';

export interface PermissionContextType {
  roleId: string | number | null;
  menuIds: Array<string | number>;
  actions: string[];
}

export const PermissionContext = createContext<PermissionContextType>({
  roleId: null,
  menuIds: [],
  actions: [],
});

export const usePermission = () => useContext(PermissionContext);
